"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var customPaste = {
  init: function init(editor) {
    // Prevents rendering links as <u href...>
    editor.on('paste', function (evt) {
      var el = document.createElement('div');
      el.innerHTML = evt.data.dataValue;
      var uElements = el.querySelectorAll('u');
      uElements.forEach(function (uElement) {
        var href = uElement.getAttribute('href');

        if (typeof href === 'string') {
          var aLink = document.createElement('a');
          aLink.setAttribute('href', href);
          aLink.innerHTML = uElement.innerHTML;
          uElement.replaceWith(aLink);
        }
      });
      evt.data.dataValue = el.innerHTML;
    });
  }
};
var _default = customPaste;
exports.default = _default;